export default {
  // common_text
  c_home: "Trang chủ",
  c_homeAdmin: "Trang chủ quản trị",
  c_create: "Thêm mới",
  c_list: "Danh sách",
  c_update: "Cập nhật",
  c_delete: "Xóa",
  c_deletes: "Xóa nhiều",
  c_detail: "Chi tiết",
  c_duplicate: "Sao chép",
  c_view: "Xem",
  c_close: "Đóng",
  c_search: "Tìm kiếm",
  c_filter: "Lọc dữ liệu",
  c_back: "Quay lại",
  c_success: "thành công",
  c_error: "không thành công",
  c_record: "bản ghi",
  c_fromDate: "Từ ngày",
  c_toDate: "Đến ngày",
  c_order: "Xắp xếp",
  c_drag: "Kéo thả",
  c_select: "Chọn",
  c_typeKeyToSearch: "Nhập từ khoá để tìm kiếm",
  c_agree: "Đồng ý",
  c_cancel: "Huỷ",
  c_sendTcqltt: "Gửi đến TCQLTT",
  c_showHideSearch: "Ẩn/hiện tìm kiếm",
  c_toggle: "Thu nhỏ/phóng to",
  c_action: "Thao tác",
  c_total: "Tổng số",
  c_toPage: "Đến trang",
  c_enter: "Nhập",
  c_yes: "Có",
  c_no: "Không",
  c_selectLeader: "Chọn làm trưởng đoàn",
  c_changeStatus: "Chuyển trạng thái",
  c_showCheckin: "Check in",
  c_showQrcode: "QR code",
  c_showHDDGDDAT: "Hướng dẫn đánh giá điểm đến",
  c_showTaiapp: "Tải app",
  c_exportExcel: "Xuất excel",

  // common_alert
  c_addSuccess: "Thêm mới thành công",
  c_addError: "Thêm mới không thành công",
  c_addduplicateError: "Mã đã tồn tại, không thể thêm mới",
  c_updateSuccess: "Cập nhật thành công",
  c_updateError: "Cập nhật không thành công",
  c_deleteSuccess: "Xóa thành công",
  c_deleteError: "Xóa không thành công",
  c_uploadError: "Tải lên không thành công",
  c_recordSuccess: "bản ghi thành công",
  c_recordError: "bản ghi không thành công",
  c_deleteConfirm: "Bạn có chắc chắn muốn xóa bản ghi này không?",
  c_notAllowAccess: "Không có quyền truy cập trang này",
  c_emptyRecord: "Bạn chưa chọn bản ghi nào",
  c_loginAgain: "Bạn cần đăng nhập trước",
  c_findError: "Lỗi tải dữ liệu",
  c_uploadConfirm: "Xác nhận upload file?",
  c_selectLeaderConfirm:
    "Bạn có chắc chắn muốn chọn khách du lịch này làm trưởng đoàn?",
  c_unselectLeaderConfirm: "Bạn có chắc chắn muốn bỏ chọn trưởng đoàn này?",
  c_addCodeSuccess: "Xử lý hoàn tất",

  // validation
  valid: "Được phép",
  valid_required: "Vui lòng nhập giá trị",
  valid_requiredChange: "Vui lòng chọn giá trị",
  valid_email: "Email không đúng định dạng",
  valid_phone: "Số điện thoại không đúng",
  valid_link: "Liên kết không đúng định dạng",
  valid_imageLink: "Liên kết ảnh không đúng định dạng",
  valid_sign: "Không được nhập ký tự có dấu",
  valid_space: "Không được nhập ký tự trắng",
  valid_script: "Không được nhập ký tự đặc biệt",
  valid_az09: "Chỉ được nhập từ a đến z, từ 0 đến 9",
  valid_az09Dot: "Chỉ được nhập a đến z ,từ 0 đến 9 và dấu chấm",
  valid_account: "Nhập từ a - z , từ 0 - 9, dấu chấm và @",
  valid_textFirst: "Ký tự đầu tiên phải là chữ",
  valid_floatNegative: "Không được nhập số âm",
  valid_dateTime: "Ngày giờ không đúng định dạng",
  valid_date: "Ngày không đúng định dạng",
  valid_year: "Năm không đúng định dạng",
  valid_month: "Tháng không đúng định dạng",
  valid_number: "Chỉ được nhập số từ 0 đến 9",
  valid_integer: "Chỉ được nhập số nguyên",
  valid_float: "Chỉ được nhập số nguyên hoặc số thập phân",
  valid_tuNgay: "Từ ngày phải nhỏ hơn hoặc bằng đến ngày",
  valid_denNgay: "Đến ngày phải lớn hơn hoặc bằng từ ngày",
  valid_upload: "Vui lòng chọn file",
  valid_file: "file",
  valid_character: "ký tự",
  valid_max: "Không được lớn hơn",
  valid_min: "Không được nhỏ hơn",
  valid_length: "Giá trị nhập phải là",
  valid_requiredUpload: "Vui lòng chọn",
  valid_password: "Nhập tổi thiểu 6 ký tự",
  valid_insertMinimum: "Nhập tổi thiểu",
  valid_insert: "Nhập từ",
  valid_to: "đến",
  valid_insertThan: "Nhập lớn hơn",
  valid_insertLess: "Nhập nhỏ hơn",
  valid_compareTime: "TG bắt đầu phải nhỏ hơn TG kết thúc",
  valid_compareStartEndTime:
    "TG bắt đầu và kết thúc phải trong khoảng TG bắt đầu và kết thúc tour",
  valid_compareTimeThongBao: "Thời điểm tạo phải nhỏ hơn thời điểm hết hạn",

  // login
  login: "Đăng nhập",
  login_error: "Tên đăng nhập hoặc mật khẩu không đúng",
  login_account: "Tên đăng nhập/Email",
  login_password: "Mật khẩu",
  login_remember: "Ghi nhớ đăng nhập",

  // logout
  logout: "Đăng xuất",
  logout_all: "Có đăng xuất khỏi các thiết bị khác?",
  logout_success: "Đăng xuất thành công",
  logout_error: "Đăng xuất không thành công",

  //change password
  c_changePasswordSuccess: "Đổi mật khẩu thành công",
  c_changePasswordError: "Đổi mật khẩu không thành công",
  c_changePasswordErrorOld: "Mật khẩu cũ không đúng",
  c_changePasswordErrorReEnterNew: "Mật khẩu nhập lại không khớp",
  c_changePasswordErrorOldNew: "Mật khẩu mới không được trùng với mật khẩu cũ",
  c_resetPassword: "Đặt lại mật khẩu",
  c_resetPasswordSuccess: "Đặt lại mật khẩu thành công",
  c_resetPasswordError: "Đặt lại mật khẩu không thành công",

  // header
  header_gotoUserProfile: "Chi tiết thông tin cá nhân",
  header_goClient: "Đến trang người dùng",
  header_goChangePassword: "Đổi mật khẩu",

  // 404 page
  p404_error: "Đường dẫn không đúng!",
  p404_backPage: "Trang trước đó",

  // nav
  nav_qlnguoidung: "Quản lý người dùng",
  nav_dsnguoidung: "Danh sách người dùng",

  // default container
  default_container_footer_header: "THÔNG TIN LIÊN HỆ, HỖ TRỢ:",
  default_container_footer_phone_number: "Điện thoại",

  // user
  User: "Người dùng",
  user: "người dùng",
  user_disableConfirm: "Bạn chắc chắn khóa người dùng này không?",
  user_undisableConfirm: "Bạn chắc chắn khóa người dùng này không?",
  user_disableSuccess: "Khóa người dùng thành công",
  user_disableError: "Khóa người dùng không thành công",
  user_undisableSuccess: "Mở khóa người dùng thành công",
  user_undisableError: "Mở khóa người dùng không thành công",
  user_nameAccount: "Tên đăng nhập",
  user_roles: "Quyền",
  user_lock: "Khóa",
  user_unlock: "Không Khóa",
  user_locked: "Đã Khóa",
  user_hidden: "Đã Ẩn",
  user_unhide: "Hiện",
  user_pinned: "Đã Ghim",
  user_unpin: "Không ghim",
  user_reEnterPass: "Nhập lại mật khẩu",
  user_password: "Mật khẩu",
  user_newPassword: "Mật khẩu mới",
  user_oldPassword: "Mật khẩu cũ",
  user_whitePassword: "Mật khẩu (Để trống là giữ nguyên mật khẩu)",
  user_position: "Chức vụ",
  user_nameUser: "Tên Người dùng",
  user_phoneNumber: "Số điện thoại",

  //user_vhtt
  user_vhtt_province: "Tỉnh quản lý",
  user_vhtt_district: "Huyện quản lý",

  // user profile
  user_profile: "Thông tin người dùng",
  user_profile_avatar: "Ảnh đại diện",
  user_profile_fullname: "Tên người dùng",
  user_profile_phone_number: "Số điện thoại",
  user_profile_email: "Email",
  user_profile_gender: "Giới tính",
  user_profile_gender_male: "Nam",
  user_profile_gender_female: "Nữ",
  user_profile_gender_NA: "Chưa có thông tin",
  user_profile_gender_other: "Khác",

  // label siderbar
  daily_safety_data: "Dữ liệu an toàn hàng ngày",
  tour_operators: "Công ty lữ hành",
  tour_list: "Danh sách tour",
  tour_ticket: "Phiếu điều tour",
  accommodation_facility: "Cơ sở lưu trú",
  tour_guide: "Hướng dẫn viên",
  tourists: "Khách du lịch",
  reflect: "Phản ánh",
  news: "Tin tức",
  high_quality_travel_service: "Dịch vụ du lịch chất lượng cao",
  evaluate: "Đánh giá",
  notification: "Thông báo",
  daily_alert: "Cảnh báo hàng ngày",
  program: "Chương trình",
  program_register: "Đăng ký chương trình",
  achievements_badge: "Thành tích huy hiệu",
  safe_destination: "Điểm đến",
  daily_safety_assessment: "Đánh giá an toàn hàng ngày",
  checkIn_safe_destination: "Check-in điểm đến",
  epidemic_area: "Vùng dịch",
  traveler_reviews: "Đánh giá khách du lịch",
  safe_destination_rating: "Đánh giá điểm đến",
  issuing_tourist_card_code: "Cấp mã thẻ du lịch",
  category: "Danh mục",
  review_team: "Nhóm đánh giá",
  reflection_group: "Nhóm phản ánh",
  news_category: "Danh mục tin tức",
  foreign_language: "Ngoại ngữ",
  nationality: "Quốc tịch",
  forte: "Sở trường",
  armorial: "Huy hiệu",
  configuration: "Cấu hình",
  user_of_category: "Người dùng",
  user_of_GDOMM: "Người dùng TCQLTT",
  version: "Phiên bản",
  SMS_query: "Truy vấn SMS",
  Ads: "Quảng cáo",

  // Công ty lữ hành - Tour operators: to_
  to_title: "công ty lữ hành",
  to_key: "Khóa",
  to_company_name: "Tên công ty",
  to_email: "Email",
  to_phone: "Điện thoại",
  to_website: "Website",
  to_address: "Địa chỉ",
  to_evaluate: "Đánh giá",
  to_action: "Thao tác",
  to_avatar: "Ảnh đại diện",
  to_vietnamese_name: "Tên tiếng Việt",
  to_english_name: "Tên tiếng Anh",
  to_hotline: "Hotline",
  to_list_of_Managers: "Danh sách người quản lý",
  to_manager: "Người quản lý",
  to_fullname: "Họ tên",
  to_gender: "Giới tính",
  to_business_license_number: "Số giấy phép kinh doanh",
  to_place_of_business_license: "Nơi cấp giấy phép kinh doanh",
  to_slogan: "Slogan",

  // Cơ sở lưu trú - Accommodation facility: af_
  af_title: "cơ sở lưu trú",
  af_name: "Tên cơ sở lưu trú",
  af_address: "Địa chỉ",
  af_type: "Loại hình",
  af_ratings: "Xếp hạng",
  af_total_number_of_rooms: "Tổng số phòng",
  af_action: "Thao tác",
  af_vietnam: " (Tiếng Việt)",
  af_english: " (Tiếng Anh)",
  af_province: "Tỉnh/TP",
  af_district: "Quận/Huyện",
  af_commune: "Xã/Phường",
  af_phone: "Điện thoại",
  af_area_code: "Mã vùng",
  af_landline_phone: "Điện thoại cố định",
  af_fax: "Số fax",
  af_logo: "Logo",
  af_email: "Email",
  af_website: "Website",
  af_service: "Dịch vụ",
  af_decision_number: "Số quyết định",
  af_decision_date: "Ngày quyết định",
  af_lowest_price: "Giá thấp nhất",
  af_highest_price: "Giá cao nhất",

  // Hướng dẫn viên - Tour guide: tg_
  tg_title: "hướng dẫn viên",
  tg_fullname: "Họ tên",
  tg_card_number: "Số thẻ",
  tg_gender: "Giới tính",
  tg_bod: "Ngày sinh",
  tg_email: "Email",
  tg_phone: "Điện thoại",
  tg_evaluate: "Đánh giá",
  tg_avatar: "Ảnh đại diện",
  tg_nationality: "Quốc tịch",
  tg_address: "Địa chỉ",
  tg_card: "Thẻ hướng dẫn viên",
  tg_card_status: "Trạng thái thẻ",
  tg_card_type: "Loại thẻ",
  tg_issued_by: "Nơi cấp",
  tg_date_range: "Ngày cấp",
  tg_expiration_date: "Ngày hết hạn",
  tg_papers: "Giấy tờ",
  tg_add_papers: "Thêm giấy tờ",
  tg_number_of_papers: "Số giấy tờ",
  tg_more_information: "Thông tin thêm",
  tg_foreign_language: "Ngoại ngữ",
  tg_forte: "Sở trường",
  tg_achievements: "Thành tích",
  tg_number_of_guided_tours: "Số tour đã hướng dẫn",
  tg_practice_history: "Lịch sử hành nghề",
  tg_number_of_years_of_practice: "Số năm hành nghề",

  // Hướng dẫn viên đã dẫn - Tour guide led: tgl_
  tgl_title: "hướng dẫn viên đã dẫn",
  tgl_fullname: "Họ tên",
  tgl_card_number: "Số thẻ",
  tgl_number_of_tour_led: "Số tour đã dẫn",
  tgl_tour_guide: "Hướng dẫn viên",
  tgl_gender: "Giới tính",
  tgl_bod: "Ngày sinh",
  tgl_email: "Email",
  tgl_phone: "Điện thoại",
  tgl_evaluate: "Đánh giá",
  tgl_avatar: "Ảnh đại diện",
  tgl_nationality: "Quốc tịch",
  tgl_card: "Thẻ hướng dẫn viên",
  tgl_card_type: "Loại thẻ",
  tgl_card_status: "Trạng thái thẻ",
  tgl_issued_by: "Nơi cấp",
  tgl_date_range: "Ngày cấp",
  tgl_expiration_date: "Ngày hết hạn",
  tgl_papers: "Giấy tờ",
  tgl_add_papers: "Thêm giấy tờ",
  tgl_papers_type: "Loại giấy tờ",
  tgl_number_of_papers: "Số giấy tờ",
  tgl_address: "Địa chỉ",
  tgl_more_information: "Thông tin thêm",
  tgl_foreign_language: "Ngoại ngữ",
  tgl_forte: "Sở trường",
  tgl_achievements: "Thành tích",
  tgl_number_of_guided_tours: "Số tour đã hướng dẫn",
  tgl_practice_history: "Lịch sử hành nghề",
  tgl_number_of_years_of_practice: "Số năm hành nghề",

  // Khách du lịch - tourists: trs_
  trs_title: "khách du lịch",
  trs_fullname: "Họ tên",
  trs_card_number: "Số thẻ",
  trs_gender: "Giới tính",
  trs_bod: "Ngày sinh",
  trs_email: "Email",
  trs_phone: "Điện thoại",
  trs_address: "Địa chỉ",
  trs_avatar: "Ảnh đại diện",
  trs_nationality: "Quốc tịch",
  trs_number_of_papers: "Số giấy tờ",
  trs_type_of_papers: "Loại giấy tờ",
  trs_issued_by: "Nơi cấp",
  trs_date_range: "Ngày cấp",
  trs_expiration_date: "Ngày hết hạn",

  // Phản ánh - Reflect: rf_
  rf_title: "phản ánh",
  rf_choose: "Chọn",
  rf_sender: "Người gửi",
  rf_sender_reflects: "Người gửi phản ánh",
  rf_reflection_group: "Nhóm phản ánh",
  rf_reflection_group_type: "Loại nhóm phản ánh",
  rf_content: "Nội dung",
  rf_time: "Thời gian",
  rf_status: "Trạng thái",
  rf_reflection_day: "Ngày phản ánh",
  rf_person_in_charge: "Người đang xử lý",
  rf_phone_number: "Số điện thoại",
  rf_reflect_to: "Phản ánh đến",
  rf_subjects_receiving_feedback: "Loại hình",
  rf_name_of_object_receiving_feedback: "Đơn vị nhận phản ánh",
  rf_reflection_time: "Thời điểm phản ánh",
  rf_attached_files: "File đính kèm",
  rf_location_on_the_map: "Địa điểm trên bản đồ",
  rf_from: "Từ",
  rf_to: "Đến",
  rf_cause: "Lý do",
  rf_transfer_history_reflects: "Lịch sử chuyển trạng thái của TCQLTT",

  // Tin tức - News: ns_
  ns_title: "tin tức",
  ns_title_label: "Tiêu đề",
  ns_place: "Địa điểm",
  ns_date_created: "Ngày tạo",
  ns_date_submitted: "Ngày đăng",
  ns_articles_status: "Trạng thái bài viết",
  ns_language: "Ngôn ngữ",
  ns_news_category: "Danh mục tin tức",
  ns_display_object: "Đối tượng hiển thị",
  ns_hide: "Ẩn",
  ns_category: "Danh mục",
  ns_created_time: "Thời điểm tạo",
  ns_posting_time: "Thời điểm đăng",
  ns_timer: "Hẹn giờ",
  ns_content: "Nội dung",
  ns_news_image: "Ảnh tin tức",
  ns_avatar: "Ảnh đại diện",
  ns_province: "Tỉnh/Thành phố",
  ns_location_on_the_map: "Địa điểm trên bản đồ",

  // Dịch vụ du lịch chất lượng cao - High quality travel service: hqts_
  hqts_title: "Dịch vụ du lịch chất lượng cao",
  hqts_hide: "Ẩn",
  hqts_service_hide: "Ẩn dịch vụ",
  hqts_services_name: "Tên dịch vụ",
  hqts_evaluate: "Đánh giá",
  hqts_pin: "Ghim",
  hqts_service_pins: "Ghim dịch vụ",
  hqts_pin_status: "Trạng thái ghim",
  hqts_approved: "Duyệt",
  hqts_date_created: "Ngày tạo",
  hqts_vietnam: " (Tiếng Việt)",
  hqts_english: " (Tiếng Anh)",
  hqts_order: "Thứ tự",
  hqts_browse_status: "Trạng thái duyệt",
  hqts_not_approved: "Chưa duyệt",
  hqts_unapproved_reason: "Lý do không duyệt",
  hqts_content: "Nội dung",
  hqts_place: "Địa điểm",
  hqts_province: "Tỉnh/Thành phố",
  hqts_district: "Quận/Huyện",
  hqts_commune: "Xã/Phường",
  hqts_address: "Địa chỉ",
  hqts_location_on_the_map: "Địa điểm trên bản đồ",
  hqts_service_image: "Ảnh dịch vụ",
  hqts_avatar: "Ảnh đại diện",
  hqts_post_photo: "Ảnh bài viết",

  // Đánh giá - Evaluate: ev_
  ev_title: "đánh giá",
  ev_assessor: "Người đánh giá",
  ev_object_type: "Loại đối tượng",
  ev_assessment_object: "Đối tượng đánh giá",
  ev_evaluate: "Đánh giá",
  ev_created_time: "Thời điểm tạo",
  ev_evaluation_object_type: "Loại đối tượng đánh giá",
  ev_enter_tour_name: "Nhập tên tour",
  ev_enter_tour_guide_name: "Nhập tên hướng dẫn viên",
  ev_enter_travel_service_name: "Nhập tên dịch vụ du lịch",
  ev_enter_safe_destination_name: "Nhập tên điểm đến",
  ev_enter_accommodation_name: "Nhập tên cơ sở lưu trú",
  ev_enter_tourists_name: "Nhập tên khách du lịch",
  ev_detailed_ingredient_evaluation: "Chi tiết đánh giá thành phần",
  ev_ingredient_evaluation_team: "Nhóm đánh giá thành phần",
  ev_value: "Giá trị",
  ev_content: "Đánh giá",
  ev_violation_criteria: "Tiêu chí vi phạm",

  // Thông báo - Notifications: ntfs_
  ntfs_title: "thông báo",
  ntfs_send_by: "Gửi theo",
  ntfs_notifications_type: "Loại thông báo",
  ntfs_title_label: "Tiêu đề",
  ntfs_notifications_content: "Nội dung thông báo",
  ntfs_created_time: "Thời điểm tạo",
  ntfs_expiration_time: "Thời điểm hết hạn",
  ntfs_start_time: "Từ ngày",
  ntfs_end_time: "Đến ngày",
  ntfs_tour: "Tour",
  ntfs_enter_keywords_to_search: "Nhập từ khóa để tìm kiếm",
  ntfs_receiver_tourists: "Người nhận (khách du lịch)",
  ntfs_receiver_tour_guide: "Người nhận (hướng dẫn viên)",
  ntfs_search_by_card_number: "Tìm theo số thẻ",
  ntfs_tourists_list: "Danh sách khách du lịch",
  ntfs_tour_guide_list: "Danh sách hướng dẫn viên",
  ntfs_fullname: "Họ tên",
  ntfs_card_number: "Số thẻ",
  ntfs_link_label: "Link",
  ntfs_gender: "Giới tính",
  ntfs_bod: "Ngày sinh",
  ntfs_email: "Email",
  ntfs_phone: "Điện thoại",
  ntfs_address: "Địa chỉ",
  ntfs_avatar: "Ảnh đại diện",
  ntfs_nationality: "Quốc tịch",
  ntfs_kdl_name: "Họ tên khách du lịch",
  ntfs_hdv_name: "Họ tên hướng dẫn viên",

  // Cảnh báo hàng ngày - Daily alert: da_
  da_title: "cảnh báo hàng ngày",
  da_content: "Nội dung",
  da_object: "Đối tượng",
  da_order: "Thứ tự",
  da_effective_date: "Ngày có hiệu lực",
  da_expiration_date: "Ngày hết hiệu lực",
  da_effect: "Hiệu lực",
  da_vietnam: " (Tiếng Việt)",
  da_english: " (Tiếng Anh)",

  // Chương trình - Program: pr_
  pr_title: "chương trình",
  pr_code: "Mã chương trình",
  pr_name: "Tên chương trình",
  pr_content: "Nội dung",
  pr_start_time: "Thời điểm bắt đầu",
  pr_end_time: "Thời điểm kết thúc",
  pr_effect: "Hiệu lực",
  pr_vietnam: " (Tiếng Việt)",
  pr_english: " (Tiếng Anh)",
  pr_add_subject_to_apply: "Thêm đối tượng áp dụng",
  pr_object_type: "Loại đối tượng",
  pr_link_survey: "Link survey",

  // Đăng ký chương trình - Program register: prr_
  prr_title: "đăng ký chương trình",
  prr_program: "Chương trình",
  prr_choose: "Chọn",
  prr_object: "Đối tượng",
  prr_created_time: "Thời điểm tạo",
  prr_update_time: "Thời điểm cập nhật",
  prr_user: "Người dùng",
  prr_badge_level: "Cấp huy hiệu",

  // Thành tích huy hiệu - Achievements badge: ab_
  ab_title: "cấp huy hiệu",
  ab_badge: "Huy hiệu",
  ab_badge_holder: "Người được cấp huy hiệu",
  ab_badge_receipt: "Thời điểm nhận",
  ab_enter_keywords_to_search: "Nhập từ khóa để tìm kiếm",
  ab_created_time: "Ngày tạo",
  ab_note: "Ghi chú",

  // Điểm đến - Safe destination: sd_
  sd_title: "điểm đến",
  sd_safe_destination_name: "Tên điểm đến",
  sd_safe_destination_type: "Loại hình",
  sd_tourist_incentives: "Giảm giá",
  sd_tour_guide_incentives: "Chiết khấu",
  sd_account_code: "Mã số tài khoản",
  sd_unit_name: "Tên điểm đến",
  sd_tax_code: "Mã số thuế",
  sd_identification_code: "Số CMT/CCCD/Hộ chiếu",
  sd_address: "Địa chỉ",
  sd_register_time: "Thời điểm đăng ký",
  sd_approved: "Duyệt",
  sd_status: "Trạng thái",
  sd_province: "Tỉnh/Thành phố",
  sd_district: "Quận/Huyện",
  sd_commune: "Phường/Xã",
  sd_enter_safe_destination_list: "Nhập danh sách điểm đến",
  sd_csotf: "TRẠNG THÁI HIỆN TẠI CỦA CƠ SỞ",
  sd_active: "Hoạt động",
  sd_unactive: "Ngừng hoạt động",
  sd_avatar: "Ảnh đại diện",
  sd_papers: "Giấy tờ",
  sd_issued_by: "Nơi cấp",
  sd_date_range: "Ngày cấp",
  sd_scanned_copy_of_business_registration: "Bản scan đăng ký doanh nghiệp",
  sd_image_papers_scan: "Ảnh giấy tờ scan",
  sd_representative: "Người đại diện",
  sd_representative_name: "Tên người đại diện",
  sd_position: "Chức vụ",
  sd_bod: "Ngày sinh",
  sd_gender: "Giới tính",
  sd_email: "Email",
  sd_phone: "Điện thoại",
  sd_safety_criteria: "Tiêu chí an toàn",

  // Hướng dẫn viên (Check-in điểm đến) - Check-in safe destination: csd_
  csd_title: "check-in điểm đến",
  csd_checkIn_time: "Thời điểm check-in",
  csd_created_object: "Đối tượng tạo",
  csd_safe_destination: "Điểm đến",
  csd_tourists: "Khách du lịch",
  csd_avatar: "Ảnh chủ thẻ",
  csd_front: "Mặt trước",
  csd_backside: "Mặt sau",
  csd_enter_keywords_to_search: "Nhập từ khóa để tìm kiếm",
  csd_travel_card_code: "Mã thẻ du lịch",
  csd_last_7_days: "7 ngày gần nhất",
  csd_last_30_days: "30 ngày gần nhất",
  csd_check_scan_qr_code:
    "XIN MỜI QUÉT MÃ QR ĐỂ CHECK IN VÀ ĐÁNH GIÁ AN TOÀN COVID-19",
  csd_print_qr: "In QR",
  csd_download_qr: "Tải QR",
  csd_fullname: "Họ và tên",
  csd_passport: "Số hộ chiếu",
  csd_qr_code: "Mã QR",
  csd_visa_approved_time: "Thời điểm duyệt visa",
  csd_user_visa_approved: "Người duyệt visa",
  csd_entry_time: "Thời điểm nhập cảnh",
  csd_user_approved: "Người xét duyệt",
  csd_cancel: "Hủy",
  csd_approved: "Đồng ý",
  csd_tourist_information: "Thông tin khách du lịch",
  csd_phone_number: "Số điện thoại",
  csd_safety_criteria: "Tiêu chí an toàn",
  csd_user_checkIn: "Người check-in",
  csd_no_data: "Chưa có dữ liệu",
  csd_user_created: "Người tạo",

  // Nhóm đánh giá - Evaluation group: eg_
  eg_title: "nhóm thành phần đánh giá",
  eg_order: "Thứ tự",
  eg_status: "Trạng thái",
  eg_object_evaluation: "Đối tượng đánh giá",
  eg_vietnamese_name: "Tên tiếng Việt",
  eg_english_name: "Tên tiếng Anh",
  eg_hide: "Ẩn",

  // Nhóm phản ánh - Reflection group: rg_
  rg_title: "nhóm phản ánh",
  rg_status: "Trạng thái",
  rg_object_reflection: "Đối tượng phản ánh",
  rg_order: "Thứ tự",
  rg_vietnamese_name: "Tên tiếng Việt",
  rg_english_name: "Tên tiếng Anh",
  rg_move_TCQLTT: "Chuyển TCQLTT",

  // Danh mục tin tức - News category: nc_
  nc_title: "danh mục tin tức",
  nc_name: "Tên",
  nc_highlights: "Nổi bật",
  nc_hide: "Ẩn",
  nc_order: "Thứ tự",
  nc_language: "Ngôn ngữ",
  nc_avatar: "Ảnh đại diện",
  nc_icon: "Icon",
  nc_language: "Ngôn ngữ",

  // Huy hiệu - Armorial: al_
  al_title: "huy hiệu",
  al_code: "Mã huy hiệu",
  al_image: "Ảnh",
  al_vietnamese_name: "Tên tiếng Việt",
  al_english_name: "Tên tiếng Anh",
  al_effect: "Hiệu lực",
  al_status: "Trạng thái",

  // Người dùng - User: user_
  user_title: "người dùng",
  user_account_name: "Tên tài khoản",
  user_name: "Tên người dùng",
  user_right_to_use: "Quyền sử dụng",
  user_avatar: "Ảnh đại diện",
  user_phone_number: "Số điện thoại",
  user_email: "Email",
  user_gender: "Giới tính",

  // Đăng ký điểm đến - Register safe destination: rsd_
  rsd_title: "điểm đến",
  rsd_safe_destination_name: "Tên điểm đến",
  rsd_safe_destination_type: "Loại điểm đến",
  rsd_address: "Địa chỉ",
  rsd_province: "Tỉnh/Thành phố",
  rsd_district: "Quận/Huyện",
  rsd_commune: "Xã/Phường",
  rsd_csotf: "TRẠNG THÁI HIỆN TẠI CỦA CƠ SỞ",
  rsd_active: "Hoạt động",
  rsd_unactive: "Ngừng hoạt động",
  rsd_avatar: "Ảnh đại diện",
  rsd_representative: "Người đại diện",
  rsd_representative_name: "Tên người đại diện",
  rsd_position: "Chức vụ",
  rsd_bod: "Ngày sinh",
  rsd_gender: "Giới tính",
  rsd_email: "Email",
  rsd_website: "Website",
  rsd_phone: "Điện thoại",
  rsd_safety_criteria: "Tiêu chí an toàn",
  rsd_business_registration: "Đăng ký kinh doanh",
  rsd_update_unit_information: "Cập nhật thông tin đơn vị",
  rsd_number_of_papers: "Số giấy tờ",
  rsd_album: "Album",
  rsd_visible_content: "Nội dung hiển thị",

  // Vùng dịch - Epidemic area: ea_
  ea_title: "vùng dịch",
  ea_province: "Tỉnh",
  ea_status: "Trạng thái dịch",
  ea_total_infections: "Tổng số nhiễm bệnh",
  ea_total_recovery: "Tổng số phục hồi",
  ea_total_death: "Tổng số tử vong",
  ea_number_of_infections: "Số ca nhiễm bệnh",
  ea_number_of_recoveries: "Số ca hồi phục",
  ea_number_of_deaths: "Số ca tử vong",
  ea_address: "Địa chỉ cụ thể",
  ea_longitude: "Kinh độ",
  ea_latitude: "Vĩ độ",
  ea_location_on_the_map: "Địa điểm trên bản đồ",
  ea_created_time: "Thời điểm tạo",

  // Đánh giá khách du lịch - Traveler reviews: tr_
  tr_title: "khách du lịch",
  tr_fullname: "Họ tên",
  tr_card_number: "Số thẻ",
  tr_gender: "Giới tính",
  tr_bod: "Ngày sinh",
  tr_email: "Email",
  tr_phone: "Điện thoại",
  tr_address: "Địa chỉ",
  tr_avatar: "Ảnh đại diện",
  tr_nationality: "Quốc tịch",
  tr_number_of_papers: "Số giấy tờ",
  tr_type_of_papers: "Loại giấy tờ",
  tr_issued_by: "Nơi cấp",
  tr_date_range: "Ngày cấp",
  tr_expiration_date: "Ngày hết hạn",
  tr_evaluate: "Đánh giá",
  tr_number_of_evaluate: "Số lượt đánh giá",

  // Chi tiết đánh giá khách du lịch - Traveler reviews detail: trd_
  trd_title: "đánh giá khách du lịch",
  trd_evaluate: "Đánh giá",
  trd_assessor: "Người đánh giá",
  trd_assessment_object: "Đối tượng đánh giá",
  trd_created_time: "Thời điểm tạo",
  trd_checkIn_time: "Thời điểm check-in",
  trd_detailed_ingredient_evaluation: "Chi tiết đánh giá thành phần",
  trd_ingredient_evaluation_team: "Nhóm đánh giá thành phần",
  trd_value: "Giá trị",
  trd_content: "Nội dung",
  trd_violation_criteria: "Tiêu chí vi phạm",

  // Đánh giá điểm đến - Safe destination rating: sdr_
  sdr_title: "điểm đến",
  sdr_safe_destination_name: "Tên điểm đến",
  sdr_safe_destination_type: "Loại điểm đến",
  sdr_register_code: "Mã đăng ký",
  sdr_tax_code: "Mã số thuế",
  sdr_address: "Địa chỉ",
  sdr_province: "Tỉnh/Thành phố",
  sdr_district: "Quận/Huyện",
  sdr_commune: "Xã/Phường",
  sdr_evaluate: "Đánh giá",
  sdr_number_of_evaluate: "Số lượt đánh giá",

  // Chi tiết đánh giá điểm đến - Safe destination rating detail: sdrd_
  sdrd_title: "đánh giá điểm đến",
  sdrd_evaluate: "Đánh giá",
  sdrd_assessor: "Người đánh giá",
  sdrd_assessment_object: "Đối tượng đánh giá",
  sdrd_created_time: "Thời điểm tạo",
  sdrd_checkIn_time: "Thời điểm check-in",
  sdrd_detailed_ingredient_evaluation: "Chi tiết đánh giá thành phần",
  sdrd_ingredient_evaluation_team: "Nhóm đánh giá thành phần",
  sdrd_value: "Giá trị",
  sdrd_content: "Nội dung",
  sdrd_violation_criteria: "Tiêu chí vi phạm",

  // Người dùng TCQLTT - Users of the General Department of Market Management: gdmm_
  gdmm_title: "cấp dưới",
  gdmm_superior: "Cấp trên",
  gdmm_user: "Người dùng",
  gdmm_subordinates: "Các cấp dưới",
  gdmm_current_user: "Người dùng hiện tại",

  // Danh sách Tour - Tour list: tl_
  tl_title: "tour",
  tl_name: "Tên tour",
  tl_group_name: "Tên đoàn",
  tl_place: "Địa điểm",
  tl_tour_venue: "Địa điểm tổ chức tour",
  tl_number_of_guests: "SL khách",
  tl_total_guests: "Tổng số lượng khách",
  tl_number_of_adults: "Số người lớn",
  tl_child_5_to_15_year: "Số trẻ em 5 - 15 tuổi",
  tl_child_under_5_year: "Số trẻ em < 5 tuổi",
  tl_start_time: "Thời gian bắt đầu",
  tl_end_time: "Thời gian kết thúc",
  tl_evaluate: "Đánh giá",
  tl_finish: "Hoàn thành",
  tl_status: "Trạng thái",
  tl_province: "Tỉnh/Thành phố",
  tl_location_on_the_map: "Địa điểm trên bản đồ",
  tl_journeys: "Hành trình",
  tl_add_journeys: "Thêm hành trình",
  tl_starting_place: "Địa điểm bắt đầu",
  tl_ending_place: "Địa điểm kết thúc",
  tl_content: "Nội dung",
  tl_car_information: "Thông tin ô tô",
  tl_license_plates: "Biển số xe",
  tl_drivers_name: "Họ tên tài xế",
  tl_driver_phone_number: "Số điện thoại tài xế",
  tl_hotel_restaurent: "Khách sạn, nhà hàng",
  tl_add_hotel: "Thêm khách sạn",
  tl_add_restaurent: "Thêm nhà hàng",
  tl_hotel_name: "Tên khách sạn",
  tl_restaurent_name: "Tên nhà hàng",
  tl_manager_name: "Tên người quản lý",
  tl_phone: "Điện thoại",
  tl_address: "Địa chỉ",
  tl_image_of_tour: "Ảnh của tour",
  tl_avatar: "Ảnh đại diện",
  tl_image_tour: "Ảnh tour",
  tl_tour_profile: "Hồ sơ tour",
  tl_tourists: "Khách du lịch",
  tl_fullname: "Họ tên",
  tl_card_number: "Số thẻ",
  tl_gender: "Giới tính",
  tl_bod: "Ngày sinh",
  tl_bom: "Tháng sinh",
  tl_boy: "Năm sinh",
  tl_email: "Email",
  tl_nationality: "Quốc tịch",
  tl_confirmed_traveler_list: "Danh sách khách du lịch đã xác nhận",
  tl_waiting_confirmed_traveler_list: "Danh sách khách du lịch chờ xác nhận",
  tl_tourists_without_card: "Danh sách khách du lịch chưa có thẻ du lịch",
  tl_tourists_in_excel_file: "Danh sách khách du lịch trong file excel",
  tl_guest_identifier: "Định danh khách - SĐT/Mã thẻ",
  tl_search_by_document_number: "Tìm theo số giấy tờ",
  tl_enter_keywords_to_search: "Nhập từ khóa để tìm kiếm",
  tl_import_from_excel_file: "Nhập từ file excel",
  tl_sample_excel_file: "File excel mẫu",
  tl_tour_guide: "Hướng dẫn viên",
  tl_confirmed_tour_guide_list: "Danh sách hướng dẫn viên đã xác nhận",
  tl_guide_card_number: "Số thẻ HDV",
  tl_title_label: "Tiêu đề",
  tl_venue_of_event: "Địa điểm diễn ra",
  tl_one_place: "1 địa điểm",
  tl_two_place: "2 địa điểm",
  tl_numerical_order: "STT",
  tl_ms_code: "Mã MS/Số thẻ",
  tl_number_of_papers: "Số giấy tờ",
  tl_type_of_papers: "Loại giấy tờ",
  tl_issued_by: "Nơi cấp",
  tl_date_range: "Ngày cấp",
  tl_month_range: "Tháng cấp",
  tl_year_range: "Ngày cấp",
  tl_expiration_date: "Ngày hết hạn",
  tl_expiration_month: "Tháng hết hạn",
  tl_expiration_year: "Năm hết hạn",
  tl_tour_guide_notification:
    "Để thêm thông tin Hướng dẫn viên Bạn cần hoàn thành Thêm mới tour sau đó sử dụng chức năng",

  // Phiếu điều tour - Tour ticket: tt_
  tt_title: "phiếu điều tour",
  tt_tour: "Tour",
  tt_tour_name: "Tên tour",
  tt_tour_guide: "Hướng dẫn viên",
  tt_start_time: "Thời gian bắt đầu",
  tt_end_time: "Thời gian kết thúc",
  tt_enter_keywords_to_search: "Nhập từ khóa để tìm kiếm",
  tt_fullname: "Họ tên",
  tt_card_number: "Số thẻ",
  tt_gender: "Giới tính",
  tt_bod: "Ngày sinh",
  tt_email: "Email",
  tt_phone: "Điện thoại",
  tt_nationality: "Quốc tịch",
  tt_confirmed_tour_guide_list: "Danh sách hướng dẫn viên đã xác nhận",
  tt_waiting_confirmed_tour_guide_list: "Danh sách hướng dẫn viên chờ xác nhận",
  tt_guide_card_number: "Số thẻ HDV",
  tt_find_tour_guide_by_card_number: "Tìm hướng dẫn viên theo số thẻ",
  tt_find_tour_guide_by_document_number: "Tìm hướng dẫn viên theo số giấy tờ",
  tt_attached_files: "File đính kèm",

  // Cấp mã thẻ du lịch - Issuing tourist card code: itcc_
  itcc_title: "cấp mã thẻ du lịch",
  itcc_surname_buffer: "Họ đệm",
  itcc_name: "Tên",
  itcc_identity: "CMND/CCCD/Hộ chiếu",
  itcc_tourist_card_registration_code: "Mã đăng ký thẻ du lịch",
  itcc_card_number: "Số thẻ",
  itcc_gender: "Giới tính",
  itcc_bod: "Ngày sinh",
  itcc_email: "Email",
  itcc_phone: "Điện thoại",
  itcc_nationality: "Quốc tịch",
  itcc_choose: "Chọn",
  itcc_number_of_papers: "Số giấy tờ",
  itcc_health_insurance_card_number: "Số thẻ BHYT",
  itcc_passport_number: "Số hộ chiếu",
  itcc_country_code: "Mã quốc gia",
  itcc_guardians: "Người giám hộ",

  // Truy vấn SMS SMS_query: sq
  sq_title: "Truy vấn SMS",
  sq_time: "Thời gian",
  sq_content: "Nội dung",

  //Quảng cáo : ads
  ads_title: "Quảng cáo",
  ads_order: "Thứ tự",
  ads_visibleImage: "Ảnh hiển thị",
  ads_link: "Link quảng cáo",
  ads_screen: "Màn hình",
  ads_visible: "Hiển thị",
  ads_banner_name: "Tên banner",
};
